import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold text-foreground-950 mb-4 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              韩漫屋
            </h4>
            <p className="text-sm text-foreground-700 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-700 hover:text-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-700 hover:text-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-700 hover:text-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-wechat-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-qq-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.qq}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 韩漫屋 - 免费在线韩国漫画阅读平台，保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              关于我们
            </Link>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}